import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const PUBLIC_JOB_POSTS_PER_PAGE = 10;

export const useGetPublicJobPostsList = () => {
  const { data, isLoading, error, send } = useRequest({
    method: ApiMethodsEnum.Get,
    sendOnStart: false,
  });

  const getPublicJobPostsList = (
    query: string = '',
    page: number = 1,
    limit: number = PUBLIC_JOB_POSTS_PER_PAGE
  ) => {
    const reqUrl = query
      ? `/api/v1/public/job-posts?limit=${limit}&page=${page}&${query}`
      : `/api/v1/public/job-posts?limit=${limit}&page=${page}`;
    send({}, reqUrl).then();
  };

  return {
    getPublicJobPostsList,
    data,
    isLoading,
    error,
  };
};
